export const ScoringSettings=[
    {
      "detailedDescription": {
        "$t": "This is the total number of Passing TDs in a game by a player or team."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Passing TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#P"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a passing TD in a game.  This rule is evaluated for EACH passing TD in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Passing TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "PS"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total passing yardage in a game.  For individual player positions like QBs, it is the GROSS passing yardage.  For team positions like the Team Offense, this is the NET passing yardage.  The NET passing yardage is the total passing yardage minus the total sack yardage against the team."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Passing Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "PY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total passing yardage divided by the number of pass completions in a game."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Average Yards per Pass Completion"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "APY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of pass attempts in a game.  It usually applies to the QB position, but other offensive players can have a pass attempt.  For example, if a team fakes a field goal, the holder or the kicker may attempt a pass.  All pass completions, incompletions, and interceptions are considered to be pass attempts."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Pass Attempts"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "PA"
      }
    },
    {
      "detailedDescription": {
        "$t": "The is the number of pass completions in a game.  It usually applies to the QB position, but other offensive positions can also have a completion.  For example, a RB might complete a pass after a handoff from the QB."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Pass Completions"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "PC"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of pass completions in a game divided by the total number of pass attempts in a game, and then multiplied by 100.  For example, if a QB completes 7 passes with 10 attempts, his completion percentage = 70.0%"
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Pass Completion Percentage"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "PCP"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of incomplete passes in a game.  This includes Interceptions."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Pass Incompletions"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "INC"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of pass interceptions thrown by a player in a game.  Do not use this rule for individual defensive players or the team defense position.  If you want to score an interception by a defensive player or the team defense, then use the rule called \"Interceptions Caught\" instead."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Pass Interceptions Thrown"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "IN"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of pass interceptions that a player throws in a game that end up being Returned all the way back for a TD.  This category is only valid for offensive positions."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Number of Interceptions Thrown Returned for a TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#IT"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a pass interception that ends up begin returned all the way back for a TD.  This category gets evaluated for EACH Interception that is Returned for a TD in a game."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Length of Interception Thrown Returned for a TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "IT"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of times a QB is sacked in a game.  It can also be used for team positions, like the Team Offense, to score the total number of sacks given up by a team.  Do not use this rule for individual defensive players.  If you want to score a sack by a defensive player, then use the \"Sacked a QB\" rule instead."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "QB Sacked"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "TSK"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total sack yards lost by a QB in a game.  It can also be used for team positions, like the Team Offense, to score the sack yards given up by the team."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "QB Sacked Yardage"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "TSY"
      }
    },
    {
      "detailedDescription": {},
      "isTeam": "0",
      "shortDescription": {
        "$t": "Passer Rating"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "RATE"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of pass completions in a game that result in a gain of 20 or more yards."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Long Passing Plays of 20+ Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "P20"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of pass completions in a game that result in a gain of 30 or more yards."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Long Passing Plays of 30+ Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "P30"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of pass completions in a game that result in a gain of 40 or more yards."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Long Passing Plays of 40+ Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "P40"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of pass completions in a game that result in a gain of 50 or more yards."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Long Passing Plays of 50+ Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "P50"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of successful two point conversion passes in a game by a player."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Passing 2 Pointers"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "P2"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of Rushing TDs in a game by a player or team."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Rushing TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#R"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a Rushing TD.  This rule is evaluated for EACH rushing TD in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Rushing TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "RS"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total rushing yardage in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Rushing Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "RY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total rushing yardage divided by the number of rush attempts in a game."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Average Yards per Rush"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "ARY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of rush attempts in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Rush Attempts"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "RA"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of rush attempts in a game that result in a gain of 20 or more yards."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Long Rushing Plays of 20+ Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "R20"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of rush attempts in a game that result in a gain of 40 or more yards."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Long Rushing Plays of 40+ Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "R40"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of successful two point conversion rushes in a game by a player."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Rushing 2 Pointers"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "R2"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of Receiving TDs in a game by a player or team."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Number of Receiving TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#C"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a Receiving TD.  This rule is evaluated for EACH receiving TD in a game."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Length of Receiving TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "RC"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total receiving yardage in a game."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Receiving Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "CY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total receiving yardage divided by the number of receptions in a game."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Average Yards per Reception"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "ACY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of receptions in a game."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Receptions"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "CC"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of times the player was targeted as the intended receiver on a passing play."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Targets"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "TGT"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of receptions in a game that result in a gain of 20 or more yards."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Long Receptions of 20+ Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "C20"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of receptions in a game that result in a gain of 40 or more yards."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Long Receptions of 40+ Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "C40"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of successful two point conversion receptions in a game by a player."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Receiving 2 Pointers"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "C2"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total Rushing plus Receiving Yards"
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Rushing + Receiving Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "RCY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total Passing plus Rushing yards"
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Passing + Rushing Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "PRY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total yards from scrimmage.  It include Passing, Rushing, and Receiving yards."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Total Yards from Scrimmage"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "TYS"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total yards.  It includes Passing, Rushing, Receiving, Punt Return, and Kickoff Return yards."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Total Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "TY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the Total Number of TDs scored by a player or team.  It includes all types of TDs."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Total Touchdowns"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#TD"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of successful field goals in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Field Goals Made"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#F"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a successful field goal.  This rule is evaluated for EACH successful field goal in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Field Goal Made"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FG"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of missed field goals in a game.  This includes field goal attempts that were blocked, but not aborted attempts in which the kicker doesn't get a chance to make the kick."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Field Goals Missed"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#M"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a missed field goal attempt.  This rule is evaluated for EACH missed field goal in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Missed Field Goal"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "MG"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of field goal attempts in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Field Goals Attempted"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#A"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of successful field goals divided by the total number of field goal attempts, and then multiplied by 100.  For example, if a kicker makes 2 field goals and misses 2 field goals in a game, then he has a 50% Field Goal Percentage."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Field Goal Percentage"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FGP"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of field goal attempts in a game that a kicker had blocked."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Field Goals Had Blocked"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "HBF"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of successful extra points in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Extra Points"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "EP"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of missed extra points in a game.  This includes extra point attempts that were blocked."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Extra Points Missed"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "EM"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of extra points attempted in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Extra Points Attempted"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "EA"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of successful extra points divided by the total number of extra point attempts, and then multiplied by 100."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Extra Point Percentage"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "EPP"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of extra points in a game that a kicker had blocked."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Extra Points Had Blocked"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "HBE"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of punts in a game.  It does not include punt attempts that were blocked."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Punts"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#N"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the GROSS punt yardage in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Punt Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "PNY"
      }
    },
    {
      "detailedDescription": {
        "$t": "The is the total punt yardage divided by the number of punts."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Average Yards per Punt"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "ANY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of punts that end up inside the opponent's 20 yard line."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Punts Inside 20"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "PI"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of punts in a game that a punter had blocked by the opponent."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Punts Had Blocked"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "HBP"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of punt returns in a game that are returned all the way for a TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Punt Return TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#UT"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a punt return TD.  This rule is evaluated for EACH punt return TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Punt Return TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "PR"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of punt returns in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Punt Returns"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#U"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total punt return yardage in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Punt Return Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "UY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total punt return yardage divided by the number of punt returns."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Average Yards per Punt Return"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "AUY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of punt returns in a game that result in a gain of 40 or more yards."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Long Punt Returns of 40+ Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "U40"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of kickoff returns in a game that are returned all the way for a TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Kickoff Return TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#KT"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a kickoff return TD.  This rule is evaluated for EACH kickoff return TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Kickoff Return TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "KO"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of kickoff returns in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Kickoff Returns"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#K"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total kickoff return yardage in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Kickoff Return Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "KY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total kickoff return yardage divided by the number of kickoff returns."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Average Yards per Kickoff Return"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "AKY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of kickoff returns in a game that result in a gain of 40 or more yards."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Long Kickoff Returns of 40+ Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "K40"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of fumbles by a player or a team in a game.  This includes \"muffs\" that occur on a punt or kickoff when a player is trying to field the kick and it bounces off his chest.  This includes ALL fumbles whether they are recovered by their own team or by the opponent.  Also, this includes ALL fumbles in the entire game, whether they are on offense or defense or special teams.  So if you assign this rule to the Team Defense position, it will include the total number of fumbles by the ENTIRE team, not just fumbles by the defense."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fumbles"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FU"
      }
    },
    {
      "detailedDescription": {
        "$t": "Includes anytime a player or team fumbles while on offense."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fumbles on Offense"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FUO"
      }
    },
    {
      "detailedDescription": {
        "$t": "Includes anytime a player or team fumbles while on special teams."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fumbles on Special Teams"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FUS"
      }
    },
    {
      "detailedDescription": {
        "$t": "Includes anytime a player or team fumbles while on defense."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fumbles on Defense"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FUD"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of fumbles by a player or team that end up being recovered by the opponent.  It does not include fumbles that are recovered by the player's own team.  Also, this includes ALL fumbles lost in the entire game, whether they are on offense or special teams.  So if you assign this rule to the Special Teams position, it will include the total number of fumbles by the ENTIRE team, even if they occurred on offense."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fumbles Lost (to Opponent)"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FL"
      }
    },
    {
      "detailedDescription": {
        "$t": "Includes anytime a player or team fumbles (and the opposing team recovers) while on offense."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fumbles Lost on Offense"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FLO"
      }
    },
    {
      "detailedDescription": {
        "$t": "Includes anytime a player or team fumbles (and the opposing team recovers) while on special teams."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fumbles Lost on Special Teams"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FLS"
      }
    },
    {
      "detailedDescription": {
        "$t": "Includes anytime a player or team fumbles (and the opposing team recovers) while on defense."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fumbles Lost on Defense"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FLD"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of fumble recoveries that are returned all the way for a TD.  This includes any fumbles by the opponent that are returned for a TD, whether they are on defense or special teams.  It does NOT include a fumble by a player's own team that is then recovered by a player and run in for a TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Defensive Fumble Recovery TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#DR"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a defensive or special teams fumble recovery TD.  This rule is evaluated for EACH fumble recovery TD in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Defensive Fumble Recovery TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "DR"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of fumbles that are recovered by a player or team.  This does not include fumbles by a player's own team that are then recovered by his team.  It only includes fumbles that are then recovered by the opponent.  This includes ALL fumble recoveries, whether they occurred on defense or special teams.  So if you assign this rule to the Team Defense position, it will include the total number of fumble recoveries by the ENTIRE team, even if they occurred on Special Teams."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fumble Recoveries (from Opponent)"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FC"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of fumbles that are recovered by a player or team while on defense. This stat is not updated during the games in the live stats. It is only updated after the games are finalized."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fumble Recoveries on Defense"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FCD"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of fumbles that are recovered by a player or team while on special teams.  This stat is not updated during the games in the live stats. It is only updated after the games are finalized."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fumble Recoveries on Special Teams"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FCS"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of yards that a player or team returned the ball after recovering a fumble that was lost by the opponent."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Opponent Fumble Recovery Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FCY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of fumbles lost by a player in a game that are returned all the way back for a TD by the other team.  For example, if a running back fumbles the ball and it ends up being recovered by the opponent and returned for a TD on the same play.  This includes fumbles that are lost on offense or on special teams."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Number of Fumbles Lost Returned for a TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#FT"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a lost fumble that ends up being returned all the way back for a TD by the opposing.  This rule is evaluated for EACH lost fumble that ends up being returned for a TD in a game."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Length of Lost Fumble Returned for a TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FT"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of fumble recoveries that are returned all the way for a TD after an offensive fumble by someone on the same NFL team. This includes fumbles that are recovered by a player's own team on any play from scrimmage. For example, if a Running Back fumbles at the 1 yard line right before scoring a TD, and then a Wide Receiver on the same team recovers the ball at the 1 yard line and advances to the endzone for a TD, then it is considered an Offensive fumble recovery TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Offensive Fumble Recovery TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#FR"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of an offensive fumble recovery that is returned all the way for a TD.  This includes fumbles that are recovered by a player's own team on any play from scrimmage. For example, if a Running Back fumbles at the 1 yard line right before scoring a TD, and then a Wide Receiver on the same team recovers the ball at the 1 yard line and advances to the endzone for a TD, then it is considered an Offensive fumble recovery TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Offensive Fumble Recovery TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FR"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of own fumble recoveries.  This ONLY includes fumbles that are recovered by a player's own team.  For example, if a Running Back fumbles at the 1 yard line right before scoring a TD, and then a Wide Receiver on the same team recovers the ball at the 1 yard line and advances to the endzone for a TD, then it is considered an Own fumble recovery TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Own Fumble Recoveries"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "OFC"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total yardage all offensive fumble recoveries.  This ONLY includes fumbles that are recovered by a player's own team.  For example, if a Running Back fumbles at the 5 yard line right before scoring a TD, and then a Wide Receiver on the same team recovers the ball at the 3 yard line and advances to the endzone for a TD, then it is considered 3 yards of own fumble recovery yardage."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Own Fumble Recovery Yardage"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "OFCY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of Forced Fumbles by a player in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Forced Fumbles"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FF"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of interceptions in a game that are returned all the way for a TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Interception Return TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#IR"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of an interception return TD.  This rule is evaluated for EACH interception return TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Interception Return TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "IR"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of interceptions by a defensive player or team defense in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Interceptions Caught"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "IC"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total return yardage by a player or team after an interception."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Interception Return Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "ICY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of time a defensive player breaks up a pass, either by knocking it down or tipping it, etc."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Passes Defended"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "PD"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of blocked field goals that are returned all the way for a TD.  The player that blocked the field goal is not necessarily the same player that returns it for a TD.  So one player could have a blocked field goal and another player could have a blocked field goal TD on the same play."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Blocked Field Goal TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#BF"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a blocked field goal TD.  This rule is evaluated for EACH blocked field goal TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Blocked Field Goal TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "BF"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of field goal attempts in a game that are blocked by a defensive player or a team defense position."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Blocked Field Goals"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "BLF"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of missed field goals in a game that are returned all the way for a TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Missed Field Goal Return TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#MF"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a missed field goal return TD. This rule is evaluated for EACH missed field goal return TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Missed Field Goal Return TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "MF"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of blocked punts that are returned all the way for a TD.  The player that blocked the punt is not necessarily the same player that returns it for a TD.  So one player could have a blocked punt and another player could have a blocked punt TD on the same play."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Blocked Punt TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#BP"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a blocked punt TD.  This rule is evaluated for EACH blocked punt TD."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Blocked Punt TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "BP"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of punt attempts in a game that are blocked by a defensive player or a team defense position."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Blocked Punts"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "BLP"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of extra point attempts that are blocked by a defensive player or a team defense position."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Blocked Extra Points"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "BLE"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of tackles in a game by a defensive player.  It does not include tackles by offensive players after a fumble recovery or an interception.  It also does not include tackles by players on special teams, such as on a punt or kickoff return.  Please be aware that tackles are NOT an official stat."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Defensive Tackles"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "TKD"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of assisted tackles in a game by a defensive player.  It does not include assists by offensive players after a fumble recovery or an interception.  It also does not include assists by players on special teams, such as on a punt or kickoff return.  Please be aware that tackles and assists are NOT an official stat."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Defensive Assists"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "ASD"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of tackles in a game by a player.  It includes tackles by an offensive player after a fumble or interception, and it includes miscellaneous tackles on special teams."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Tackles"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "TK"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of assisted tackles in a game by a player.  It includes assists by an offensive player after a fumble or interception, and it includes miscellaneous assists on special teams."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Assists"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "AS"
      }
    },
    {
      "detailedDescription": {},
      "isTeam": "0",
      "shortDescription": {
        "$t": "Assists Divided by 2"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "AS2"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of sacks in a game by a defensive player or the team defense position.  Individual defensive players can have 1/2 sacks."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Sacked a QB"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "SK"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total lost yardage of the sacks in a game by a defensive player or a team defense position.  Individual defensive players can have 1/2 yards."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Sacked a QB Yardage"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "SKY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of times a defensive player makes a hit on a Quarterback behind the line of scrimmage during a pass attempt. It is not updated during live scoring."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Quarterback Hits"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "QH"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of Tackles for a Loss in a game by a defensive player. This stat is not updated during the games in the live stats. It is only updated after the games are finalized."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Tackles for a Loss"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "TKL"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of Safeties in a game by a defensive player or a team defense position.  It includes ALL safeties whether they are on defense or special teams."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Safeties"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "SF"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total points scored against a team in a game.  (This matches the scoreboard points at the end of a game).  If your league chooses to not include those points scored by the Defense then please see our <a href=\"http://%HOST%/%YEAR%/support?L=%LEAGUEID%&amp;FAQ=472\" target=\"_blank\">Help Center</a> for additional setup options."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Total Points Allowed"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "TPA"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the points scored against a team on Special Teams, which only includes points scored on Punt Returns and Kickoff Returns.  It also includes any conversion points scored after the TD (extra point or a 2 Pt Conversion)"
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Special Teams Points Against"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "STPA"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the points scored against a team on Offense, which only includes points scored via Passing and Rushing TDs as well as Field Goals. It also includes any conversion points scored after the TDs (extra point or a 2 Pt Conversion)."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Offensive Points Against"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "OPA"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total yardage allowed by a team in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Total Net Yards Allowed"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "TYA"
      }
    },
    {
      "detailedDescription": {
        "$t": "This the total passing yardage allowed by a team in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Total Net Yards Passing Allowed"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "TYP"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total rushing yardage allowed by a team in a game."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Total Net Yards Rushing Allowed"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "TYR"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of TDs allowed on Special Teams, which only includes Punt Return and Kickoff Return TDs scored by the opponent."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Special Teams TDs Allowed"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "STTA"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of TDs allowed on Offense, which only includes Passing and Rushing TDs scored by the opponent."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Offensive TDs Allowed"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "OTA"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of Defensive TDs scored.  It includes Interception Return TDs and Opponent Fumble Recovery TDs."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Defensive TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#D"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a Defensive TD.  It includes Interception Return TDs and Opponent Fumble Recovery TDs."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Defensive TD"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "DD"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of defensive two point conversion returns in a game.  This can be scored by blocking an extra point attempt, or by intercepting a 2-point conversion pass attempt, or by recovering a 2-point conversion fumble, and then returning it all the way to the other end zone."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Defensive Conversion Returns"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "D2"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of one point safeties in a game.  This can be scored on a 2-point conversion attempt by tackling the opponent in their own end zone."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Safeties for 1 Point"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "SF1"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of successful two point conversions."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Successful 2 Point Conversions"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "M2"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of failed two point conversion attempts."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Failed 2 Point Conversions"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "F2"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of Defensive and Special Teams TDs scored. It includes Interception Return TDs, Opponent Fumble Recovery TDs, Blocked Punt TDs, Blocked FG TDs, Punt Return TDs, Kickoff Return TDs, and Missed FG Return TDs."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Number of Defensive & Special Teams TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "#T"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the length in yards of a Defensive or Special Teams TD. It includes Interception Return TDs, Opponent Fumble Recovery TDs, Blocked Punt TDs, Blocked FG TDs, Punt Return TDs, Kickoff Return TDs, and Missed FG Return TDs."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Length of Defensive/Special Teams TDs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "TT"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of penalties for the team or player.  It is not divided between offense and defense.  For example, if you assign this rule to the Team Defense, then they will be scored for all of the penalties by the entire team, whether they occurred on offense or defense.  Note that this stat is not updated live for individual players."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Penalties"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "F"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total yardage lost on all of the penalties by the team or player.  Note that this stat is not updated live for individual players."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Penalty Yards"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FY"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the time of possession in minutes for a team."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Time of Possession (in Minutes)"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "TIME"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total points scored by a team."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Total Points Scored"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "TPS"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the difference in score between the team and the opponent.  It can be positive or zero or negative.  For example, if a team wins a game 20 to 17, then the point differential is 3.  If a team loses a game 30 to 21, then the point differential is -9 (negative 9).  This rule can be used to score a \"WIN\" or a \"LOSS\" or a \"TIE\" for a team position or an individual player.  A point differential of 1 or more is considered a WIN.  A point differential of -1 or less is considered a LOSS.  A point differential of 0 is a TIE."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Point Differential"
      },
      "isCoach": "1",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "DIF"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the offensive points scored by a team.  It includes Passing and Rushing TDs, as well as Field Goals"
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Offensive Points Only"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "OPS"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the total number of First Downs for the team or player."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "First Downs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "FD"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of Passing First Downs gained by the team or player."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Passing First Downs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "1P"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of Rushing First Downs gained by the team or player."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Rushing First Downs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "1R"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of Receiving First Downs gained by the player."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Receiving First Downs"
      },
      "isCoach": "0",
      "isPlayer": "1",
      "abbreviation": {
        "$t": "1C"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of First Downs gained because of Penalties."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Penalty First Downs"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "1F"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of successful third down conversions by the entire team."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Third Down Conversions"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "3D"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of failed third down conversion attempts by the entire team."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Third Downs Failed"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "3F"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of successful fourth down conversions by the entire team."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fourth Down Conversions"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "4D"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of failed fourth down conversion attempts by the entire team."
      },
      "isTeam": "1",
      "shortDescription": {
        "$t": "Fourth Downs Failed"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "4F"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of wins a coach has."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Games Won"
      },
      "isCoach": "1",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "W"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of losses a coach has."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Games Lost"
      },
      "isCoach": "1",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "L"
      }
    },
    {
      "detailedDescription": {
        "$t": "This is the number of ties a coach has."
      },
      "isTeam": "0",
      "shortDescription": {
        "$t": "Games Tied"
      },
      "isCoach": "1",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "T"
      }
    },
    {
      "detailedDescription": {},
      "isTeam": "0",
      "shortDescription": {
        "$t": "Average Passing Yards Allowed per Game"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "APYAG"
      }
    },
    {
      "detailedDescription": {},
      "isTeam": "0",
      "shortDescription": {
        "$t": "Passing Defense Rank"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "APYAR"
      }
    },
    {
      "detailedDescription": {},
      "isTeam": "0",
      "shortDescription": {
        "$t": "Average Rushing Yards Allowed per Game"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "ARYAG"
      }
    },
    {
      "detailedDescription": {},
      "isTeam": "0",
      "shortDescription": {
        "$t": "Rushing Defense Rank"
      },
      "isCoach": "0",
      "isPlayer": "0",
      "abbreviation": {
        "$t": "ARYAR"
      }
    }
  ]